import React from "react";
import PgHomeBase from "../SHARED/components/PgHomeBase";

export default function PgContactHome() {
  return <PgHomeBase variant="contact" />;
}
